
	var $grid = $('.picture').imagesLoaded( function() {
	  $grid.masonry({
			itemSelector: '.grid-item',
			percentPosition: true,
			columnWidth: '.grid-sizer'
	  });
	});

$('.picture').each( function() {
	var $pic     = $(this),
		getItems = function() {
			var items = [];
			$pic.find('a').each(function() {
			var $href   = $(this).attr('href'),
				$size   = $(this).data('size').split('x'),
				$width  = $size[0],
				$height = $size[1];

			var item = {
				src : $href,
				w   : $width,
				h   : $height,
				title	: $(this).attr('data-caption')
			};

			items.push(item);
			});

			return items;
		};

	var items = getItems();

	var $pswp = $('.pswp')[0];
	$pic.on('click', 'figure', function(event) {
		event.preventDefault();

		var $index = $( "figure" ).index( this );
		var options = {
			index: $index,
			bgOpacity: 0.7
		};

	// Initialize PhotoSwipe
		var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
		lightBox.listen('gettingData', function(index, item) {

			if (item.w < 1 || item.h < 1) { // unknown size

				var img = new Image();
				img.onload = function() { // will get size after load
					item.w = this.width; // set image width
					item.h = this.height; // set image height
					 lightBox.invalidateCurrItems(); // reinit Items
					lightBox.updateSize(true); // reinit Items
				};
				img.src = item.src; // let's download image
			}
		});

		lightBox.init();
	});
});
